import { ProductSupplierInventoryReceiptDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { observeProductSupplierInventoryReceipt } from 'src/utils/firebase/firebase-short-cut';

const useProductSupplierInventoryReceipts = (transactionDate: string) => {
  const [productSupplierInventoryReceipts, setProductSupplierInventoryReceipts] = useState<
    ProductSupplierInventoryReceiptDoc[]
  >([]);

  useEffect(() => {
    const productSupplierInventoryReceipt$ = observeProductSupplierInventoryReceipt([
      ['transactionDate', '==', transactionDate],
    ]);

    const subscription = productSupplierInventoryReceipt$.subscribe((productSupplierInventoryReceipts) => {
      setProductSupplierInventoryReceipts(productSupplierInventoryReceipts);
    });

    return () => subscription.unsubscribe();
  }, [transactionDate]);

  return productSupplierInventoryReceipts;
};

export default useProductSupplierInventoryReceipts;
